// Import the Loading component from the "./Globals" file
import { Loading } from "./Globals";

// Export the Loading component as the default export
export default Loading;
